import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();
  const { language } = useLanguage();

  const handleHomeClick = () => {
    // Preserve the language parameter when navigating
    const params = new URLSearchParams(location.search);
    const langParam = params.get('lang');
    navigate(langParam ? `/?lang=${langParam}` : '/');
  };

  return (
    <div className="min-h-screen bg-white pt-32">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-9xl font-bold text-bamboo-200 mb-8">404</h1>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            {language === 'de' 
              ? 'Seite nicht gefunden'
              : 'ページが見つかりません'}
          </h2>
          <p className="text-gray-600 mb-8">
            {language === 'de'
              ? 'Die von Ihnen gesuchte Seite existiert nicht oder wurde verschoben.'
              : 'お探しのページは存在しないか、移動された可能性があります。'}
          </p>
          <button
            onClick={handleHomeClick}
            className="inline-flex items-center gap-2 bg-bamboo-600 text-white px-6 py-3 rounded-lg hover:bg-bamboo-700 transition-colors"
          >
            <ChevronLeft size={20} />
            {language === 'de' ? 'Zur Startseite' : 'ホームに戻る'}
          </button>
        </div>
      </div>
    </div>
  );
}
